import * as types from "./customerInformationActionTypes";

export default (state = {}, action) => {
    switch (action.type) {
    case types.LOAD_CUSTOMER_INFORMATION_SUCCESS:
            return action.customerInformation;  
    default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/customer-information/CustomerInformationReducer.js